'use client';
import { useCallback, useEffect, useRef } from 'react';

export function EndOfArticle({ isVideo, id }) {
  // Scrolltiefe für Artikel in Analytics #367
  const endOfArticleElement = useRef<HTMLParagraphElement>(null);
  const readTimeRef = useRef(false);
  const reached95Percent = useRef(false);

  const maybeReadArticle = useCallback(() => {
    if (readTimeRef.current && reached95Percent.current) {
      window.dataLayer?.push({
        event: 'custom_event',
        event_name: 'article_read',
      });
    }
  }, []);

  useEffect(() => {
    if (!endOfArticleElement.current) {
      console.error('endOfArticleElement must be set');
      return;
    }

    if (isVideo) {
      return;
    }

    let articleViewedPercent = 0;

    const onScroll = () => {
      const elementTop =
        endOfArticleElement?.current?.getBoundingClientRect().top;
      if (elementTop === undefined) return;

      const artilceHeight = window.pageYOffset + elementTop;
      const elementScrollPosition =
        artilceHeight - (elementTop - window.innerHeight);
      const articleViewedPercentNow =
        Math.min(Math.max(elementScrollPosition / artilceHeight, 0), 1) * 100;
      const milestones = [25, 50, 75, 100];

      if (articleViewedPercentNow >= 95 && !reached95Percent.current) {
        reached95Percent.current = true;
        maybeReadArticle();
      }

      for (const milestone of milestones) {
        if (
          articleViewedPercent < milestone &&
          milestone <= articleViewedPercentNow
        ) {
          window.dataLayer?.push({
            event: 'custom_event',
            event_name: 'scroll',
            scroll: {
              scroll_depth: `${milestone}%`,
              event_value: milestone,
            },
          });
        }
      }

      articleViewedPercent = Math.max(
        articleViewedPercentNow,
        articleViewedPercent,
      );

      if (articleViewedPercent === 100) {
        window.removeEventListener('scroll', onScroll);
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [id, isVideo, maybeReadArticle]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      readTimeRef.current = true;
      maybeReadArticle();
    }, 10000);
    return () => {
      clearTimeout(timeout);
    };
  }, [id, maybeReadArticle]);

  return <div ref={endOfArticleElement} className="w-[1px] h-[1px]"></div>;
}
